/**
 * @file  src\components\Inventory\CreateInventory\NiceToHave\OtherNiceToHaves.js
 * @brief  This file is responsible for nice to have selection in inventory creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const OtherNiceToHaves = (props) => {
    const {others, handleItemClick, itemArray} = props
    return  <NiceToHaveHelper
       list={others}
       selectedItems={itemArray}
       propertyClick={handleItemClick}
    />
};
export default OtherNiceToHaves;
